/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : REMOVE IMAGE INDICATOR : STYLES --------------- ++++++++++ */
export default theme => ({
	removeimageindicator: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		height: pxToEm(34),
		width: pxToEm(34),
		zIndex: '9',
		cursor: 'pointer',
		opacity: '1',
		background: `rgba(255, 255, 255, 0.3)`,
		padding: replacePXinStringWithEM(`5px 10px`),
		borderRadius: pxToEm(6),
		transition: 'all .2s ease-in-out 0s',
		'& img':{
			width: pxToEm(19)
		}
	}
});
